module.exports = __webpack_public_path__ + "static/images/jdxl.68807d2.png";